module.exports = __webpack_public_path__ + "static/media/safer.4a8ea3f7.png";